import PropTypes from 'prop-types'
import React from 'react'
import moment, { displayFormat } from 'helpers/moment'
import classes from './Picklists.scss'

const getOrders = (orders) => orders
  .filter(o => o.product && o.product.type && o.product.type.report === 'smallfish')
  .sort((a, b) => a.route.name - b.route.name)
  .sort((a, b) => a.customer.name - b.customer.name)
  .sort((a, b) => a.product.name - b.product.name)

const getSums = (orders) => {
  orders = getOrders(orders)
  const array = {}

  for (let i in orders) {
    const order = orders[i]
    const key = `${order.product_id}-${order.uom_id}`

    if (!array[key]) {
      array[key] = {
        product: order.product.name,
        uom: order.uom.shorthand || order.uom.name,
        qty: 0
      }
    }

    array[key].qty += order.qty
  }

  return Object.values(array) // convert object array to array
}

const getDate = (orders) => {
  if (orders && orders[0] && orders[0].date) {
    return moment(orders[0].date).format(displayFormat)
  }

  return ''
}

export const Picklist = (props) => {
  if (!getSums(props.orders).length) return null

  return (
    <div className={classes.picklist}>
      <header className={classes.header}>
        <span className={classes.route} />
        <span className={classes.customer}>TwoXSea Smallfish Picklist</span>
        <span className={classes.date}>{getDate(props.orders)}</span>
      </header>

      <table className={classes.table}>
        <thead>
          <tr>
            <th className={classes.left}>name</th>
            <th className={classes.right}>qty</th>
          </tr>
        </thead>
        <tbody>
          {getSums(props.orders).map((sum, index) => (
            <tr key={index}>
              <td className={classes.left}>{sum.product}</td>
              <td className={classes.right}>{sum.qty} {sum.uom}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

Picklist.propTypes = {
  orders: PropTypes.array
}

export default Picklist



// WEBPACK FOOTER //
// ./src/components/Reports/Smallfish/Picklists/Picklists.js